import {AreaConfig, PuckType, SpriteConfigBasic, SpriteConfigName} from "@/entities/game/types";

export const GAME_LAYOUT = {

    //Отступ рамок поля (c двух сторон)
    baseOffsetSquare: 40,

    //Отступ у контейнера
    padding: 40,
    //Высота hud
    hudH: 72,
    //Отступ сверху (100 отступ для подлноэкранного)
    topPadding: 100,
    //Высота блока таймер
    tournamentTimer: 65,
    //Отступ снизу (83 высота меню + 12 отступ от меню до кнопки + 53 высота кнопки удара + 12 отступ от кнопки до поля)
    bottomPadding: 160,
    //Отступ сверху от бортика до ворот
    topPaddingGate: 20,
    //Отступ снизу от бортика до хоккеиста
    bottomPaddingPlayer: 20,

    paddingPuckForPlayerX: 25,
    paddingPuckForPlayerY: 25,

    paddingGoalkeeper: 45,

} as const

export const GAME_SPEED = {
    //Базовая скорость для хоккеиста и ворот
    base: 200,
    //Базовая скорость для полета шайбы при ударе
    puck: 800,
    //Скорость поворота при ударе
    rotation: 18,
}

export const AREA: AreaConfig = {
    width: 350,
    height: 492,
    baseWidth: 350,
    baseHeight: 492,
    x: 0,
    y: 0,
}
export const SPRITES_SQUARE: Record<PuckType, SpriteConfigBasic> = {
    [PuckType.BASIC]: {
        speed: 0,
        imageKey: 'square',
        baseWidth: 350,
        baseHeight: 492,
        type: PuckType.BASIC
    },
    [PuckType.FIRE]: {
        speed: 0,
        imageKey: 'square',
        baseWidth: 350,
        baseHeight: 492,
        type: PuckType.BASIC
    },
    [PuckType.GOLDEN]: {
        speed: 0,
        imageKey: 'square',
        baseWidth: 350,
        baseHeight: 492,
        type: PuckType.BASIC
    },
};
export const SPRITES_player: Record<PuckType, SpriteConfigBasic> = {
    [PuckType.BASIC]: {
        speed: 1.8,
        imageKey: 'player',
        baseWidth: 32.25,
        baseHeight: 52.25,
        type: PuckType.BASIC
    },
    [PuckType.FIRE]: {
        speed: 1.8,
        imageKey: 'playerFire',
        baseWidth: 39.5,
        baseHeight: 59,
        type: PuckType.FIRE
    },
    [PuckType.GOLDEN]: {
        speed: 1.8,
        imageKey: 'player',
        baseWidth: 32.25,
        baseHeight: 52.25,
        type: PuckType.GOLDEN
    },
};


export const SPRITES_PUCK: Record<PuckType, SpriteConfigBasic> = {
    [PuckType.BASIC]: {
        speed: 1,
        imageKey: 'puck',
        baseWidth: 8,
        baseHeight: 8,
        type: PuckType.BASIC
    },
    [PuckType.FIRE]: {
        speed: 1.5,
        imageKey: 'puckFire',
        baseWidth: 8,
        baseHeight: 12,
        type: PuckType.FIRE
    },
    [PuckType.GOLDEN]: {
        speed: 1,
        imageKey: 'puckGold',
        baseWidth: 8,
        baseHeight: 8,
        type: PuckType.GOLDEN
    }
};

export const SPRITES_GATE: Record<PuckType, SpriteConfigBasic> = {
    [PuckType.BASIC]: {
        speed: 1.1,
        imageKey: 'gate',
        baseWidth: 67.3,
        baseHeight: 16,
        type: PuckType.BASIC
    },
    [PuckType.FIRE]: {
        speed: 1.1,
        imageKey: 'gate',
        baseWidth: 67.3,
        baseHeight: 16,
        type: PuckType.BASIC
    },
    [PuckType.GOLDEN]: {
        speed: 1.1,
        imageKey: 'gate',
        baseWidth: 67.3,
        baseHeight: 16,
        type: PuckType.BASIC
    },
};

export const SPRITES_GOALKEEPER: Record<PuckType, SpriteConfigBasic> = {
    [PuckType.BASIC]: {
        speed: 1.4,
        imageKey: 'goalkeeper',
        baseWidth: 39,
        baseHeight: 44,
        type: PuckType.BASIC
    },
    [PuckType.FIRE]: {
        speed: 1.4,
        imageKey: 'goalkeeper',
        baseWidth: 39,
        baseHeight: 44,
        type: PuckType.BASIC
    },
    [PuckType.GOLDEN]: {
        speed: 1.4,
        imageKey: 'goalkeeper',
        baseWidth: 39,
        baseHeight: 44,
        type: PuckType.BASIC
    },
};
export const SPRITE_REGISTRY = {
    [SpriteConfigName.player]: SPRITES_player,
    [SpriteConfigName.puck]: SPRITES_PUCK,
    [SpriteConfigName.goalkeeper]: SPRITES_GOALKEEPER,
    [SpriteConfigName.gate]: SPRITES_GATE,
    [SpriteConfigName.square]: SPRITES_SQUARE,
} as const;


export enum GameChangeEvent {
    HitStreakChanged = 'HitStreakChanged',
    PuckTypeChanged = 'PuckTypeChanged',
    InventoryBonusChanged = 'InventoryBonusChanged',
    QuestBonusChanged = 'QuestBonusChanged',
}

export const EVENT_SPRITE_DEPENDENCIES: Record<
    GameChangeEvent,
    SpriteConfigName[]
> = {
    [GameChangeEvent.HitStreakChanged]: [
        SpriteConfigName.gate,
    ],

    [GameChangeEvent.PuckTypeChanged]: [
        SpriteConfigName.player,
        SpriteConfigName.puck,
    ],

    [GameChangeEvent.InventoryBonusChanged]: [
        SpriteConfigName.goalkeeper
    ],

    [GameChangeEvent.QuestBonusChanged]: [],
};
